import PropTypes from 'prop-types';
import React from 'react';
import {ListItemButton, ListItemText} from '@mui/material';
import {useTranslation} from 'react-i18next';

const SearchInputOption = ({option, ...props}) => {
  const {t} = useTranslation();
  const primary = option.title;
  let secondary = option.description;

  if (option.descriptionDetails?.length) {
    secondary = option.descriptionDetails.join(t('global.listJoin'));
  }

  return (
    <ListItemButton {...props}>
      <ListItemText
        primary={primary}
        secondary={secondary}
        primaryTypographyProps={{noWrap: true}}
        data-qe="search-suggestion"
      />
    </ListItemButton>
  );
};

SearchInputOption.propTypes = {
  option: PropTypes.shape({
    description: PropTypes.string,
    descriptionDetails: PropTypes.array,
    source: PropTypes.string,
    context: PropTypes.object,
    title: PropTypes.string,
  }),
};

export default SearchInputOption;
